export const ANALYSIS_WIDTH = 256
export const ANALYSIS_HEIGHT = 192

export default class FrameSampler {
    constructor(width = ANALYSIS_WIDTH, height = ANALYSIS_HEIGHT) {
        this.canvas = document.createElement('canvas')
        this.canvas.width = width
        this.canvas.height = height
        this.ctx = this.canvas.getContext('2d', { willReadFrequently: true })
        this._cache = null
        this._cacheStamp = -1
    }

    get width() {
        return this.canvas.width
    }

    get height() {
        return this.canvas.height
    }

    sample(video, stamp) {
        if (stamp != null && stamp === this._cacheStamp && this._cache) {
            return this._cache
        }
        this.ctx.drawImage(video, 0, 0, this.canvas.width, this.canvas.height)
        const data = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height)
        this._cache = data
        this._cacheStamp = stamp == null ? -1 : stamp
        return data
    }
}
